'use client';

import Script from "next/script";

/* PushOwl SMS/Email notifications */
export default function PushOwlScript({ storeHash }: { storeHash?: string }) {
  if (storeHash) {
    return (
      <Script id="push-owl-script" strategy="afterInteractive">
        {`
          window.pushowl = window.pushowl || {
            queue: [],
            trigger: function (taskName, taskData) {
              return new Promise((resolve, reject) => {
                this.queue.push({
                taskName,
                taskData,
                promise: { resolve, reject }
                })
              })
            },
            init: function () {
              const subdomain = '${storeHash}'
              const platform = 'bigcommerce'
              if (!subdomain) {
                return
              }
              this.subdomain = subdomain
              var s = document.createElement('script')
              s.type = 'text/javascript'
              s.async = true
              s.src =
                'https://cdn.pushowl.com/sdks/pushowl-sdk.js?subdomain=' +
                subdomain +
                '&environment=production&shop=' +
                subdomain +
                ".my" +
                platform +
                ".com" +
                "&platform=" +
                platform;
              var x = document.getElementsByTagName('script')[0]
              x.parentNode.insertBefore(s, x)
            }
        };
        window.pushowl.init();
      `}</Script>
    );
  }
}
